import * as React from "react";
import Button from "@mui/material/Button";
import { Dialog, Box, OutlinedInput, Typography, Stack } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Slide from "@mui/material/Slide";
import notifier from "../Notifier";
import LockIcon from "@mui/icons-material/Lock";
import {
  checkExtension,
  getErrorString,
  isEmpty,
} from "../../constants/function";
import ApiService from "../../services/api-service";
import { Upload } from "react-iconly";
import Loader from "../Loader";
import { getUserId } from "./../../constants/function";
import PageHeader from "./../../components/PageHeader";
import NoData from "./../../components/Nodata";
import DoneIcon from "@mui/icons-material/Done";
import { useTranslation } from "react-i18next";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AddMusicToPlaylist(props) {
  const { t } = useTranslation("common");
  const [id, setId] = React.useState(null);
  const [playlist, setPlaylist] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pageNo, setPageNo] = React.useState(1);
  const [loaded, setLoaded] = React.useState(false);
  const getPlaylist = async (_id, next) => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_ALL_(_id);
      setLoading(false);
      // setLoaded(response["result"].length < 10 ? true : false);
      setPlaylist(response["result"]);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getAlbums = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.MY_ALBUM(`${_id}`);
      setLoading(false);
      setPlaylist([...response["result"]]);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const save = async (playlistId) => {
    try {
      setLoading(true);
      const response = await ApiService.ADD_SONG_TO_PLAYLIST({
        musicId: props["musicId"],
        playlistId: playlistId,
      });
      notifier.success(t("notifier.success.toast19"));
      setLoading(false);
      props.handleClose();
    } catch (error) {
      notifier.error(getErrorString(error));
      setLoading(false);
    }
  };
  const saveToAlbum = async (albumId) => {
    try {
      setLoading(true);
      const response = await ApiService.ADD_SONGS_TO_ALBUM({
        musicId: props["musicId"],
        albumId: albumId,
      });
      notifier.success(t("notifier.success.toast19"));
      setLoading(false);
      props.handleClose();
    } catch (error) {
      notifier.error(getErrorString(error));
      setLoading(false);
    }
  };
  React.useEffect(() => {
    if (props["isAlbum"]) getAlbums(getUserId());
    else getPlaylist(getUserId(), pageNo);
  }, []);
  const handleScroll = async (target) => {
    if (props["isAlbum"]) return;
    var a = target.scrollTop;
    var b = target.scrollHeight - target.clientHeight;

    if ((a / b) * 100 > 80 && !loading && !loaded) {
      // run a function called doSomething
      const next = pageNo + 1;
      setPageNo(next);
      getPlaylist(getUserId(), next);
    }
  };
  return (
    <div>
      <Dialog
        onBackdropClick={() => props.handleClose(null, true)}
        open={props.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => props.handleClose(null, false)}
        PaperProps={{
          style: {
            // backgroundColor: "#1E1E1E",
            backgroundColor: "rgb(0 0 0)",
            boxShadow: "none",
            color: "#000000",
            borderRadius: 16,
            height: "80vh",
            margin: "0",
            width: "100%",
          },
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <Stack spacing={1} sx={{ height: "inherit" }}>
          <Typography className="text-center p-10">
            {props["isAlbum"] ? t("dropMenu.m4") : t("dropMenu.m3")}
          </Typography>
          <Stack
            sx={{ padding: "16px", height: "calc(100% - 83px)" }}
            spacing={1}
            className="p55"
          >
            <Stack
              // onScroll={(e) => handleScroll(e.target)}
              spacing={1}
              sx={{
                minHeight: "calc(100% - 100px)",
                overflow: "scroll",
                paddingBottom: "50px",
              }}
            >
              {playlist?.length > 0 ? (
                playlist.map((p, index) => (
                  <Stack
                    style={{
                      cursor: "pointer",
                      borderRadius: "25px",
                      background: id === p["_id"] ? "#262626" : "#1A1A1A",
                      padding: "10px",
                    }}
                    direction="row"
                    alignItems="center"
                    gap="10px"
                    key={index}
                    onClick={() =>
                      setId(id && id === p["_id"] ? null : p["_id"])
                    }
                  >
                    <Typography>{p["title"]}</Typography>
                    {p["private"] && !props["isAlbum"] ? (
                      <LockIcon className="__small_icon" />
                    ) : null}
                    {id === p["_id"] ? (
                      <DoneIcon
                        className="bg_primary ml_auto br-50 fs-14 p2"
                        color="secondary"
                      />
                    ) : null}
                  </Stack>
                ))
              ) : (
                <NoData
                  lable={
                    props["isAlbum"]
                      ? t("noData.message2")
                      : t("noData.message3")
                  }
                />
              )}
            </Stack>
            {playlist?.length > 0 ? (
              <Button
                startIcon={<AddIcon color="secondary" />}
                variant="contained"
                color="primary"
                onClick={() => (props["isAlbum"] ? saveToAlbum(id) : save(id))}
              >
                {props["isAlbum"] ? t("dropMenu.m4") : t("dropMenu.m3")}
              </Button>
            ) : null}
          </Stack>
        </Stack>
        {loading ? (
          <Loader
            wait={true}
            message={
              props["isAlbum"]
                ? t("loader.message3")
                : `${t("loader.message27")} ${
                    pageNo > 1 ? t("loader.message5") : ""
                  } ${t("loader.message6")}`
            }
          />
        ) : null}
      </Dialog>
    </div>
  );
}
